import React, {useEffect, useState} from "react";
import JoinAgree from "../components/JoinAgree";
import JoinInput from "../components/JoinInput";
import {UserInterface} from "../model/UserInterface";
import JoinComplete from "../components/JoinComplete";
import {useTypedSelector} from "../reducers";


const JoinPage = () => {
    const { site, status } = useTypedSelector(state => state.profile);
    const [termYn, setTermYn] = useState("N");
    const [privacyYn, setPrivacyYn] = useState("N");
    const [visibleYn, setVisibleYn] = useState('true');
    const [secondStepVisibleYn, setSecondStepVisibleYn] = useState('true')
    const [userNm, setUserNm] = useState('')

    const [joinData, setJoinData] = useState<UserInterface>();

    useEffect(() => {
        if(status === 'idle') return;
        if (joinData !== undefined) insertJoinData(joinData);
    }, [termYn, privacyYn, visibleYn, joinData, userNm, status]);

    const insertJoinData = async (data: UserInterface | undefined) => {
        if (data) {
            setVisibleYn('false')
            setUserNm(data["usrNm"]);
        }
    }
    const getTermYn = (agreementYn: string) => {
        setTermYn(agreementYn);
    }

    const getPrivacyYn = (agreementYn: string) => {
        setPrivacyYn(agreementYn);
    }

    const getParentVisibleYn = (visibleYn: string) => {
        setVisibleYn(visibleYn);
    }

    const getSecondStepVisibleYn = (visibleYn: string) => {
        setSecondStepVisibleYn(visibleYn);
    }

    const getJoinData = (data: UserInterface) => {
        setJoinData(data);
    }

    const isRequireTel = () => {
        return site === 'ncdc';
    }

    return (
        <div className={'join-page-wrapper wrapper'}>
            <div className={'join-page-content content'}>
                <div className={'join-page-title'}>
                    <span>회원가입</span>
                    <div className={'join-page-title-circle'}/>
                </div>
                <div className={'join-page-tab-wrapper'}>
                    <div className={'join-page-tab-content flex-space-between'}>
                        <div className={`join-page-tab-item flex-center ${visibleYn === 'true' ? 'active' : ''}`}>약관
                            동의
                        </div>
                        <div
                            className={`join-page-tab-item flex-center  ${secondStepVisibleYn === 'true' && visibleYn === 'false' ? 'active' : ''}`}>개인정보
                            입력
                        </div>
                        <div
                            className={`join-page-tab-item flex-center ${secondStepVisibleYn === 'false' ? 'active' : ''}`}>회원가입
                            완료
                        </div>
                    </div>
                </div>
                <div className={'join-page-component-wrapper'}>
                    <JoinAgree getTermYn={getTermYn} getPrivacyYn={getPrivacyYn}
                               childVisibleStyle={getParentVisibleYn}/>
                    <JoinInput childInsertData={getJoinData} firstStepVisibleYn={visibleYn}
                               secondStepVisibleYn={secondStepVisibleYn}
                               isRequireTel={isRequireTel()}
                               secondStepVisibleStyle={getSecondStepVisibleYn}/>
                    <JoinComplete usrNm={userNm} secondStepVisibleYn={secondStepVisibleYn}/>
                    {/*<JoinNiceModuleSuccess/>*/}
                    {/*<JoinNiceModuleFail/>*/}

                </div>
            </div>
        </div>
    );
}

export default JoinPage;
